function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function UserCard(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "17",
    height: "16",
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("rect", {
    x: "2.184",
    y: "4.2",
    width: "13.6",
    height: "8.6",
    rx: ".8",
    fill: "#BFF6F8",
    stroke: "#528693",
    strokeWidth: ".4"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: "5.984",
    cy: "8.5",
    r: "2.2",
    fill: "#fff",
    stroke: "#528693",
    strokeWidth: ".4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.484 8.2a.7.7 0 1 0 0-1.4h-3.5a.7.7 0 1 0 0 1.4h3.5ZM10.484 10.2a.7.7 0 1 0 0-1.4h-.5a.7.7 0 1 0 0 1.4h.5Z",
    fill: "#fff",
    stroke: "#528693",
    strokeWidth: ".4"
  }));
}

export default UserCard;